import { Injectable, EventEmitter } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { RoomParserService } from './room-parser.service';
import { IRoomManager} from './room-manager';
import {UserTypeManagerService} from '../usertype/user-type-manager.service';
import {MediaManagerService, OnMedia, OnTalking} from '../media/media-manager.service';
import {WbService} from '../../../wb/wb.service';
import {WsService2} from '../ws/ws.service';
declare var $;
export interface OnPeer{
    onPeer(peer);
}
@Injectable()
export class RoomManagerService implements IRoomManager, OnMedia {
    techCheck = false;
    setTechCheck(to){
        this.techCheck = to;
    }
    kick(whi){
        this.roomParser.sendKick(whi);
    }
    onPeerConnected(media, callee){
        if (media!='audio-snapshots')
            this.peers[callee]["snapshot"]=undefined;
        try{
            $("#video-"+callee).css("height", "auto");
        }catch(error){}
    }
    constructor(private wsService: WsService2,private roomParser: RoomParserService, private userTypeManager: UserTypeManagerService, private wbService: WbService, private mediaManager: MediaManagerService) {
        console.log("Creating room manager");
        roomParser.setRoomManager(this);
        mediaManager.registerOnMediaCallback(this);
    }
    
  
 updatePeers(peers){
       console.log("Will update peers");
       for (let k in this.peers){
           var found = false;
           for (let p of peers){
               if (p==k){
                   found = true;
                   break;
               }
           }
           if (!found){
               try{
                   this.mediaManager.onExited(k);
               }catch(error){}
               try{
                   this.onExited(k);
               }catch(error){}
           }
       }
   }
    callbacks=[];
    sendBye(){
        this.roomParser.sendBye();
    }
    registerCallback(cb:OnPeer){
        for (let p of this.callbacks){
            if (p == cb)return;
        }
        this.callbacks.push(cb);
    }
    unregisterCallback(cb){
        for (var i =0;i<this.callbacks.length;i++){
            if (this.callbacks[i] == cb)
            delete this.callbacks[i];
        }
        
    }
    raisedHand(who, raised){
        this.peers[who].raised=raised;
    }
    peers = [];
    onExited(who) {
        delete this.peers[who];
         var self = this;
         setTimeout(function(){
            
            self.wbService.onResize();
        },100)
        this.notifyOnPeer(who, false);
       /* setTimeout(function(){
            self.onPeerEvent.emit();
        }, 10);
        */console.log("Removing user  ", who);
    }
    raiseHand(to, raised){
        this.roomParser.sendRaiseHand(to, raised);
    }
    //onPeerEvent = new EventEmitter();
    notifyOnPeer(p, entered){
         for (let a of this.callbacks){
            a.onPeer(p, entered);
        }
    }
    onPeer(who, name, me, type) {
        console.log("Got on peer ", who, name);
        if (name==""){
            this.roomParser.sendGotPeer(who);
            return;
        }
        if (!this.peers[who])
        this.peers[who] = { name: name, who: who, me: me, type: type };
        if (me){
            this.userTypeManager.onUserType(type);
        }
        this.roomParser.sendGotPeer(who);
        var self = this;
        setTimeout(function(){
            self.wbService.onResize();
        }, 10)
        var self = this;
        this.notifyOnPeer(this.peers[who], true);
        /*setTimeout(function(){
            self.onPeerEvent.emit();
        }, 10); 
*/        
    }
  //  handler
    onConnected() {
        this.roomParser.onJoin(false, this.techCheck);
        // var self = this
        // if (this.handler){
        //     try{
        //     clearInterval(this.handler)
        //     }catch(error){}
        // }
        // this.handler = setInterval(function(){
            
        //     for (let p of Object.keys(self.peers)){
        //         try{
        //             var a = $("#video-"+p)[0].play();
        //             if (a!==null){
        //                 a.catch((e)=>{
        //                     console.log("Got error ", e);
        //                 })
        //             }
        //             //clearInterval(self.handler);
        //         }catch(error){
        //             var e = error;
        //             console.log("Got error ", error);
        //         }
        //     }
        // }, 1000);
    }
    onDisconnected() {
        this.peers=[];
    }
     getPeers(){
       return this.peers;
   }
   updatePeer(hash, param, value){
       this.peers[hash][param]=value;
      
   }
    onMediaError(error){}
    onMediaConnected(media){
        console.log("WILL TrY to resize")
        
        this.wbService.onResize()
    }
	onMediaReconnected(){
        this.onDisconnected();
        this.onConnected();
    }
	onIncomingUpdated(who, connected){
        this.updatePeer(who, "incoming", connected);
        this.wbService.onResize()
    }
	onMediaUpdated(who, media){
        this.updatePeer(who, "media", media);
        this.onPeerConnected(media, who);
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/room/room-manager.service.ts